<template>
  <div class="recharge-list-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1400px" :before-close="handleClose" :close-on-click-modal="false" class="el-dialogs">
      <!--操作栏-->
      <div class="action-bar">
        <el-input size="small" clearable placeholder="流水id" v-model="params.id" @keyup.native.enter="getRechargeList('status')" class="param-input" />
        <el-input size="small" clearable placeholder="用户id" v-model.number="params.uid" @keyup.native.enter="getRechargeList('status')" class="param-input" />
        充值类型:
         <el-select v-model="params.rechargeType" clearable size="small" placeholder="请选择充值类型" @change="getRechargeList('status')" >
           <el-option v-for="item in rechageList" :value="item.value" :label="item.label" :key="item.value" ></el-option>
          </el-select>
        订单状态:
          <el-select v-model.number="params.status" clearable size="small" placeholder="请选择订单状态" @change="getRechargeList('status')">
            <el-option v-for="item in statusList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
        
        <el-button type="primary" size="small" @click="getRechargeList('status')">搜索</el-button>
      </div>
      <div class="price-box">总充值金额: {{rchgordMoney  | numFormat}}元</div>
      <!--数据表格-->
      <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-table-column prop="districtCode" label="商区码" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.districtCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="流水id" align="center" min-width="220" fixed>
          <template slot-scope="scope">
            <span>{{scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="uid" label="用户id" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.uid }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="promSeqe" label="推广序列" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.promSeqe }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="linkRemark" label="链接备注" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.linkRemark }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="devID" show-overflow-tooltip label="设备id" align="center" min-width="320">
          <template slot-scope="scope">
            <span>{{scope.row.devID }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oid" label="支付平台订单号" align="center" min-width="320">
          <template slot-scope="scope">
            <span>{{scope.row.oid }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userIP" show-overflow-tooltip label="用户IP" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.userIP }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户名称" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tel" label="用户手机号码" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.tel }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payAct" label="支付账号" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.payAct }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="devType" label="设备系统类型" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.devType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金币" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{(scope.row.amount || '0') | numFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="充值金额" align="center" min-width="140">
          <template slot-scope="scope">
            <span>{{(scope.row.money/100 || '0') | numFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payMoney" label="实际到账金额" align="center" min-width="240">
          <template slot-scope="scope">
            <span>{{(scope.row.payMoney || '0') | numFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rechargeType" label="充值类型" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.rechargeType | rechargeRule}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.status | statusRule}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusDesc" label="状态描述" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.statusDesc || '无'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" align="center" min-width="220">
          <template slot-scope="scope">
            <span>{{scope.row.createdAt | changeDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updatedAt" label="更新时间" align="center" min-width="220">
          <template slot-scope="scope">
            <span>{{scope.row.updatedAt | changeDate}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" align="center" fixed="right" width="130">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="editDesc(scope.row)"></el-button>
        </template>
      </el-table-column> -->
      </el-table>
      <el-pagination :page-sizes="[5]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 5" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
      <div class="zw"></div>
    </el-dialog>

  </div>
</template>
<script>
import { changeTime } from '@/utils/global'
import API from '@/api'
export default {
  data() {
    return {
      dialogVisible: false,
      title: '充值记录查看',
      tableData: [],
      time: '',
      rchgordMoney: 0,
      loading: false,
      total: 0,
      // 充值类型选择
      rechageList:[
        {
          value: 'alipay',
          label: '支付宝'
        },
        {
          value: 'wechat',
          label: '微信'
        },
        {
          value: 'bankcard',
          label: '银行卡'
        }
      ],
      // 订单状态选择 
      statusList:[
        {
          value: 0,
          label: '下单失败'
        },
        {
          value: 1,
          label: '进行中'
        },
        {
          value: 2,
          label: '付款失败'
        },
        {
          value: 3,
          label: '付款成功'
        },
        {
          value: 4,
          label: '已经退款'
        },
      ],
      // 请求订单列表参数
      params: {
        discCode:'',
        pageNumber: 1,
        pageSize: 5,
        startTime: '',
        id: '',
        uid: '',
        rechargeType: '',
        status: 3,
        endTime: '',
        agent: '',
      }
    }
  },
  filters: {
    rechargeRule(val) {
      const typeList = {
        alipay: '支付宝',
        wechat: '微信',
        bankcard: '银行卡'
      }
      return typeList[val] ? typeList[val] : '未知'
    },
    statusRule(val) {
      const statusList = {
        0: '下单失败',
        1: '进行中',
        2: '付款失败',
        3: '付款成功',
        4: '已经退款',
      }
      return statusList[val] ? statusList[val] : '未知'
    },
  },
  methods: {
    // 请求订单列表
    getRechargeList(type) {
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      this.loading = true
      API.getRechargeList(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
          this.rchgordMoney = res.data.rchgordMoney
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRechargeList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRechargeList()
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || ''
        this.params.endTime = changeTime(time[1]) || ''
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.getRechargeList('status')
    },
    // 打开弹窗
    open(row) {
      this.dialogVisible = true;
      this.params.agent = row.agent;
      this.params.discCode = row.districtCode
      this.getRechargeList();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params= {
        pageNumber: 1,
        pageSize: 5,
        startTime: '',
        id: '',
        uid: '',
        rechargeType: '',
        status: 3,
        endTime: '',
        agent: ''
      }
    }
  }
}
</script>
<style lang="scss">
.recharge-list-box {
  .icon {
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
    color: #e63765;
    vertical-align: middle !important;
    &:hover {
      color: #eb5f84;
    }
  }
  .zw {
    height: 100px;
  }
  .price-box {
    font-size: 16px;
  }
}
</style>

